<template>
  <recipes-legacy v-if="useLegacy" @new-view="useNewView" />
  <div v-else-if="restaurantId">
    <recipes-mobile v-if="isPhone" />
    <recipes-desktop v-else />
  </div>
  <div v-else class="pa-6">
    <page-header icon="mdi-book-open-page-variant" :title="$t('recipes')" :subtitle="$t('please_select_restaurant_to_view_data')" />
  </div>
</template>

<script>
import hasRecipesState from "@/components/recipes-shell/hasRecipesState";
import RecipesDesktop from "@/components/recipes-shell/RecipesDesktop.vue";
import RecipesLegacy from "@/components/recipes-shell/RecipesLegacy.vue";
import RecipesMobile from "@/components/recipes-shell/mobile/RecipesMobile.vue";

/**
 * Recepti (/recipes): količine namirnica po jelima i smjenama. Računar: gornja navigacija (Po jelima / Zbirno) i ista
 * traka filtera kao u izvještajima i magacinu; telefon (širina do 600 px): kartice jela i donji listovi.
 * ?ui=stari vraća staru stranicu. Stanje (period, smjene, prikaz, jela, izmijenjene porcije, učitavanje, štampa i Excel)
 * je u hasRecipesState, pa izmjene ne nestaju kad se prozor suzi do telefona i vrati.
 */
export default {
  name: "RestaurantRecipesPage",
  mixins: [hasRecipesState],
  components: { RecipesDesktop, RecipesMobile, RecipesLegacy },
};
</script>
